import {
  Box,
  Icon,
  Image,
  Paper,
  Typography,
  useTheme
} from "@outschool/backpack";
import { faPlus } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

import patterns from "../../../../images/banners/welcome/patterns.png";
import { useUpsertLearner } from "../hooks/useUpsertLearner";
import AddLearnerModal from "./AddLearnerModal";

export default function AddLearnerButton() {
  const theme = useTheme();
  const { t } = useTranslation(
    "client\\components\\parentDashboardV2\\components\\AddLearnerButton"
  );

  const { openModal, ...rest } = useUpsertLearner();

  return (
    <>
      <AddLearnerModal {...rest} />
      <Paper
        sx={{
          borderRadius: 16,
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 16,
          pl: 24,
          pr: 72,
          backgroundColor: theme.palette.primary[700],
          cursor: "pointer",
          position: "relative",
          overflow: "hidden",
          height: 76,
          "&:hover": {
            backgroundColor: theme.palette.primary[600]
          },
          "&:hover .add-learner-icon": {
            backgroundColor: theme.palette.primary[700]
          },
          "&:hover .add-learner-icon-text": {
            color: theme.palette.common.white
          },
          transition: "background-color 0.2s ease-in-out",
          [theme.breakpoints.down("md")]: {
            py: 16
          },
          [theme.breakpoints.down("sm")]: {
            pl: 14
          }
        }}
        onClick={() => {
          openModal();
        }}
      >
        <Box
          className="add-learner-icon"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: theme.palette.common.white,
            borderRadius: "100%",
            width: 42,
            height: 42,
            transition: "all 0.2s ease-in-out",
            flexShrink: 0
          }}
        >
          <Icon
            icon={faPlus}
            className="add-learner-icon-text"
            sx={{
              color: theme.palette.primary[700],
              fontSize: "1.25rem"
            }}
          />
        </Box>
        <Typography variant="h6">
          {t("Add a learner to get class recommendations")}
        </Typography>
        <Image
          src={patterns}
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            width: 92
          }}
        />
      </Paper>
    </>
  );
}
